import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { setVideoTrending } from "../../../services/content";

/**
 * Button that puts a video in trending or takes it out. `compact`: icon
 * button for the table rows. `onChange(isTrending)` after a success.
 */
const TrendingToggle = ({ video, compact = false, onChange }) => {
  const { t } = useTranslation();
  const [on, setOn] = useState(Boolean(video?.isTrending));
  const [busy, setBusy] = useState(false);
  useEffect(() => setOn(Boolean(video?.isTrending)), [video?.isTrending]);

  if (!video || video.isShort) return null;
  const label = on ? t("Remove from trending") : t("Put in trending");

  const toggle = async (event) => {
    event.stopPropagation();
    setBusy(true);
    try {
      const result = await setVideoTrending(video._id, !on);
      setOn(result.isTrending);
      toast.success(
        result.isTrending
          ? t("In trending: on the home page of the site, and in the app as the latest trending video")
          : t("Removed from trending")
      );
      onChange && onChange(result.isTrending);
    } catch (error) {
      toast.error(error?.response?.data?.message || t("Error updating data"));
    } finally {
      setBusy(false);
    }
  };

  return compact ? (
    <button
      type="button"
      className="ui-icon-btn"
      data-active={on || undefined}
      title={label}
      aria-label={label}
      aria-pressed={on}
      disabled={busy}
      onClick={toggle}
    >
      <i className={on ? "ri-fire-fill" : "ri-fire-line"} aria-hidden="true"></i>
    </button>
  ) : (
    <button type="button" className="ui-btn ui-btn-secondary" aria-pressed={on} disabled={busy} onClick={toggle}>
      <i className={on ? "ri-fire-fill trending-on" : "ri-fire-line"} aria-hidden="true"></i>
      {label}
    </button>
  );
};

export default TrendingToggle;
